import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {isEmpty} from 'lodash';
import styled from 'styled-components';

import {
  Typography,
  IconButton,
  FormControl,
  Button,
  Dialog,
  FormControlLabel,
  Switch,
  CircularProgress,
  Chip,
  Box
} from '@mui/material';
import {withRouter} from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownload from '@mui/icons-material/CloudDownload';
import * as actions from '../../../store/actions';
import Spinner from '../../../components/Spinner/index';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import {
  FormStyled,
  DoneIconStyled,
  DivSubmitButtons,
  DivFormTitle,
} from '../Forms/styles';

import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import confirm from '../../../UI/Confirm/confirm';

import ModalEquipmentServicesGroup from './ModalEquipmentServicesGroup';
import ModalEquipmentServicesQuestion from './ModalEquipmentServicesQuestion';
import SiteSelector from '../../../UI/SiteSelector/SiteSelector';
import hasSiteAccess from '../../../utils/hasSiteAccess';

import Checklist from '../../../components/Checklist/Checklist';
import { GroupCreateButton, DeleteChecklistButton, MassinveImportButton } from '../../../components/Checklist/styles';
import { i18n } from '../../../translate/i18n';
import extractPositionFromName from '../../../utils/orderChecklist';
import { deleteCheckMessage } from '../../../utils/deleteCheckMessage';
import ModalMassiveImport from './ModalMassiveImport';
import { orderQuestionArray } from '../../../utils/orderQuestionArray';
import api from '../../../axios/api';
import { LoadingButton } from '@mui/lab';
import WarningModal from '../../../components/WarningModal';


const ModalParamEquipmentServices = (props) => {
  const dispatch = useDispatch();

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState('name');
  const [order, setOrder] = useState('asc');

  const [actualValue, setActualValue] = useState();
  const [groupQuestionArray, setGroupQuestionArray] = useState([]);

  const [modalGroupContentQuestion, setModalGroupContentQuestion] = useState();
  const [showEditGroup, setShowEditGroup] = useState();
  const [showEditQuestion, setShowEditQuestion] = useState();

  const [openModalGroup, setOpenModalGroup] = useState(false);
  const [openModalQuestion, setOpenModalQuestion] = useState(false);
  const [openModalMassiveImport, setOpenModalMassiveImport] = useState(false);

  const [modalContentGroup, setModalContentGroup] = useState();
  const [modalContentQuestion, setModalContentQuestion] = useState();

  const [isNewData, setIsNewData] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [serviceTypesError, setServiceTypesError] = useState(false);
  const [frequencyError, setFrequencyError] = useState(false);
  const [changesOnStage, setChangesOnStage] = useState(false);

  // selected values on autocomplete
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState([]);

  const [searchTextServiceTypes, setSearchTextServiceTypes] = useState('');
  const [searchTextFrequency, setSearchTextFrequency] = useState('');

  const [serviceTypesFormated, setServiceTypesFormated] = useState({});
  const [frequencyFormated, setFrequencyFormated] = useState({});

  const [mandatory, setMandatory] = useState(true);
  const [massService, setMassService] = useState(false);
  const [expirationOnLastDayOfMonth, setExpirationOnLastDayOfMonth] = useState(false);
  const [mandatoryActions, setMandatoryActions] = useState(false);
  const [enableSignature, setEnableSignature] = useState(false);
  const [mandatorySignature, setMandatorySignature] = useState(false);
  
  const [downloadingExcell, setDowndloadingExcell] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const selectedSites = useSelector((state) => state.sites.selectedSitesQuestions);
  const selectedAccess = useSelector((state) => state.auth.selectedAccess);
  const role = useSelector((state) => state.auth.selectedAccess.role);
  const superadmin = useSelector(state => state.auth.superadmin)
  const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);

  // fetch from BE
  const fetchServiceTypes = useCallback(
    () =>
      dispatch(
        actions.fetchServiceTypes(
          page,
          limit,
          searchTextServiceTypes,
          order,
          orderBy
        )
      ),
    [page, limit, searchTextServiceTypes, order, orderBy]
  );

  const fetchFrequency = useCallback(
    () =>
      dispatch(
        actions.fetchFrequency(
          page,
          limit,
          searchTextFrequency,
          order,
          orderBy,
          selectedServiceTypes ? selectedServiceTypes.value : ''
        )
      ),
    [page, limit, searchTextFrequency, order, orderBy, selectedServiceTypes]
  );

  // get from redux
  const serviceTypes = useSelector((state) => state.serviceTypes.serviceTypes);
  const frequencies = useSelector((state) => state.frequency.frequencies);

  const loadingServiceTypes = useSelector((state) => state.serviceTypes.loading);
  const loadingFrequency = useSelector((state) => state.frequency.loading);

  const loading = useSelector(state => state.equipmentServices.loading);
  const loadingChecklist = useSelector(state => state.equipmentModels.loadingChecklist);

  // post to BE
  const postEquipmentServices = (body) => dispatch(actions.postEquipmentServices(body));
  const updateEquipmentServices = (index, body) => dispatch(actions.updateEquipmentServices(index, body));
  const deleteEquipmentServices = (index) => dispatch(actions.deleteEquipmentServices(index));
  const checkDeleteEquipmentServices = (index) => dispatch(actions.checkDeleteEquipmentServices(index))
  const deleteChecklistBySite = (equipmentModelId, equipmentServiceId, siteId) => dispatch(actions.deleteChecklistBySite(equipmentModelId, equipmentServiceId, siteId));
  const deleteQuestion = (index) => dispatch(actions.deleteQuestions(index));
  const inactivateService = () => dispatch(actions.inactivateEquipmentService(props.modalContent._id, equipmentModel._id));
  const activateService = () => dispatch(actions.activateEquipmentService(props.modalContent._id, equipmentModel._id));

  // FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = serviceTypes;
    const returnArray = [];
    dataFromRedux.rows.map((dt) =>
      returnArray.push({value: dt._id, label: dt.name})
    );
    setServiceTypesFormated(returnArray);
  }, [serviceTypes]);

  useEffect(() => {
    const dataFromRedux = frequencies;
    const returnArray = [];
    dataFromRedux.rows.map((dt) =>
      returnArray.push({value: dt._id, label: dt.name})
    );
    setFrequencyFormated(returnArray);
  }, [frequencies]);

  useEffect(() => {
    fetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy);
  }, [searchTextServiceTypes]);

  useEffect(() => {
    fetchFrequency(page, limit, searchTextFrequency, order, orderBy);
  }, [searchTextFrequency]);

  // check if is newEntrance or editing
  useEffect(() => {
    setActualValue(props.modalContent);
  }, []);
  
  useEffect(() => {
    if (props.modalContent) {
      let equipmentData = [];
      if (props.active) {
        equipmentData = equipmentModel.equipmentServices.filter((equip) => {
          return equip._id === props.modalContent._id
        });
      }
      else {
        equipmentData = equipmentModel.inactiveEquipmentServices.filter((equip) => {
          return equip._id === props.modalContent._id
        });
      }
      setActualValue(equipmentData[0])
    }
   
  }, [equipmentModel]);

  const selectSite = useCallback((site) =>
    dispatch(actions.selectSiteQuestions(site))
  );

  useEffect(() => {
    if (!isEmpty(actualValue)) {
      formThreeData();
    }
  }, [selectedSites]);

  const recovery = () => {
    if (!isEmpty(actualValue)) {
      const { serviceType } = actualValue;
      const freq = actualValue.frequency;
      setMandatory(actualValue.mandatory);
      setMassService(actualValue.massService);
      setExpirationOnLastDayOfMonth(actualValue.expirationOnLastDayOfMonth);
      setMandatoryActions(actualValue.mandatoryActionsForNotComplyQuestions);
      setEnableSignature(actualValue.enableSignature);
      setMandatorySignature(actualValue.mandatorySignature);

      if (serviceType) {
        setSelectedServiceTypes({
          value: serviceType._id,
          label: serviceType.name,
        });
      }
      if (freq) {
        setSelectedFrequency({value: freq._id, label: freq.name});
        setIsNewData(false);
        formThreeData();
      }
    } else {
      setSelectedFrequency({});
      setSelectedServiceTypes({});
      setIsNewData(true);
      setMandatory(true)
      setMassService(false);
      setExpirationOnLastDayOfMonth(false);
      setMandatoryActions(false);
      setEnableSignature(true);
      setMandatorySignature(false);
    }
  }

  useEffect(() => {
    recovery()
  }, [actualValue]);

  const formThreeData = () => {
    if (selectedSites.length > 0) {
      const { questions } = actualValue;
      const groupArray = [];
      if (questions) {
        questions.forEach((question) => {
          if (
            question.type === 'group' &&
            question.site === selectedSites[0]._id
          ) {
            question.questionArray = [];
            extractPositionFromName(question)
            groupArray.push(question);
          }
        });

        const groupArrayOrdered = groupArray.sort(orderQuestionArray);

        questions.forEach((question) => {
          if (question.type === 'question') {
            const index = groupArrayOrdered.findIndex(
              (ga) => ga._id === question.groupId
            );
            if (index > -1) {
              extractPositionFromName(question)
              groupArrayOrdered[index].questionArray.push(question);
            }
          }
        });

        groupArrayOrdered.forEach(groupArray => {
          groupArray.questionArray = groupArray.questionArray.sort(orderQuestionArray);
        })

        setGroupQuestionArray(groupArrayOrdered);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (isEmpty(selectedServiceTypes)) {
      setServiceTypesError(true);
      hasError = true;
    }

    if (isEmpty(selectedFrequency)) {
      setFrequencyError(true);
      hasError = true;
    }

    if (hasError) return;

    const body = {
      serviceType: selectedServiceTypes.value,
      frequency: selectedFrequency.value,
      equipmentModelId: props.match.params.id,
      mandatory,
      massService,
      expirationOnLastDayOfMonth,
      mandatoryActionsForNotComplyQuestions: mandatoryActions,
      enableSignature,
      mandatorySignature,
    };

    if (isNewData) {
      postEquipmentServices(body).then((result) => {
        if (result !== 'error') {
          props.closeModal(false, '');
          dispatch(actions.fetchEquipmentModelById(props.match.params.id))
        }
      });
    } else {
      updateEquipmentServices(actualValue._id, body).then((result) => {
        if (result !== 'error') {
          props.closeModal(false, '');
          dispatch(actions.fetchEquipmentModelById(props.match.params.id))
        }
      });
    }
  };

  const handleCheckDeleteEquipmentServices = (documentName) => {
    checkDeleteEquipmentServices(documentName._id).then((res) => {
      if (isEmpty(res)) {
        handleDeleteService(documentName)
      } else {
        handleDeleteEquipmentModelsFail(res)
      }
    })
  }

  const handleDeleteService = (actualValue) => {
    confirm(i18n.t('handleDeleteServiceModalEquipService.confirm'), {
      title: i18n.t('handleDeleteServiceModalEquipService.title'),
      titleColor: 'red',
      disableBackdrop: true,
    }).then(
      () => {},
      async () => {
        deleteEquipmentServices(actualValue._id).then((result) => {
          if (result !== 'error') {
            props.closeModal(false, '');
            dispatch(actions.fetchEquipmentModelById(props.match.params.id))
          }
        });
      }
    );
  };

  const handleDeleteEquipmentModelsFail = (obj) => {
    confirm(`${deleteCheckMessage(obj)}`,
      {
        title: i18n.t('handleDeleteEquipmentServiceFail.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
        },
      )
  }

  const handleInputChangeSelectorServiceTypes = (text) => {
    setSearchTextServiceTypes(text);
  };

  const handleInputChangeServiceTypes = (selected) => {
    setServiceTypesError(false);
    setSelectedServiceTypes(selected);
  };

  const handleInputChangeSelectorFrequency = (text) => {
    setSearchTextFrequency(text);
  };

  const handleInputChangeFrequency = (selected) => {
    setFrequencyError(false);
    setSelectedFrequency(selected);
  };

  const handleClickCancelEdit = () => {
    // restore default function
    recovery()
    setEditMode(false);
  };

  const handleClickEditGroup = (e, cl) => {
    e.preventDefault()
    e.stopPropagation();
    setModalContentGroup(cl);
    setOpenModalGroup(true);
  };

  const handleClickEditQuestion = (cl, group) => {
    setModalGroupContentQuestion(group);
    setModalContentQuestion(cl);
    setOpenModalQuestion(true);
  };

  const handleClickAddGroup = () => {
    setModalContentGroup();
    setOpenModalGroup(true);
  };
  
  const handleClickMassiveImport = () => {
    if (superadmin) {
      setOpenModalMassiveImport(true);
    }
  }

  const handleClickExport = () => {
    setDowndloadingExcell(true);
    const siteId = selectedSites[0]._id;
    const equipmentServiceId = actualValue?._id;
    api.get(`/equipmentservices/${equipmentServiceId}/${siteId}/checklistexportsuperadmin`)
      .then(response => {
        if (response) {
          window.open(response.data.url, "_blank")
        }
        setDowndloadingExcell(false);
      });
  }

  // Method to clean the checklist by site
  const deletingActualChecklist = (site) => {
    const aux = Object.assign({}, actualValue);
    let questionsToStay = [];
    aux.questions.forEach((q, index) => {
      if (q.site !== site) {
        questionsToStay.push(q);
      }
    });
    setActualValue({ ...aux, questions: questionsToStay });
  };

  const handleClickDeleteChecklist = () => {
    confirm(i18n.t('handleClickDeleteChecklistModalEquipService.confirm'), {
      title: i18n.t('handleClickDeleteChecklistModalEquipService.title'),
      titleColor: 'red',
      disableBackdrop: true,
    }).then(() => {}, async () => {
      if (selectedSites.length > 0) {
        deleteChecklistBySite(equipmentModel._id, actualValue._id, selectedSites[0]._id).then((result) => {
          if (result !== 'error') {
            deletingActualChecklist(selectedSites[0]._id);
          }
        });
      }
    });
  };

  const handleClickAddQuestion = (e, group) => {
    e.preventDefault()
    e.stopPropagation();
    setModalGroupContentQuestion(group);
    setModalContentQuestion();
    setOpenModalQuestion(true);
  };

  const closeAndCleanModal = () => {
    setModalContentGroup();
    setModalContentQuestion();
    setChangesOnStage(false);
    setOpenModalQuestion(false);
    setOpenModalGroup(false);
    setOpenModalMassiveImport(false);
  }

  const handleCloseModal = (result) => {
    if (result) {
      setActualValue(result);
    }

    closeAndCleanModal();
  };

  const handleCloseDialog = (type) => {
    if (type === 'question' && changesOnStage) {
      confirm(`${i18n.t('handleCloseDialogModalEquipService.confirm')}`, {
        title: i18n.t('handleCloseDialogModalEquipService.title'),
        titleColor: 'red',
        disableBackdrop: true,
      }).then(
        () => {},
        () => {
          closeAndCleanModal();
        }
      )
    }
    else {
      closeAndCleanModal();
    }
  };

  const handleDeleteQuestion = (question) => {
    confirm(`${i18n.t('handleDeleteQuestionModalEquipService.confirm')} ${question.name}?`, {
      title: i18n.t('handleDeleteQuestionModalEquipService.title'),
      titleColor: 'red',
      disableBackdrop: true,
    }).then(
      () => {},
      async () => {
        deleteQuestion(question).then((result) => {
          if (result !== 'error') {
            dispatch(actions.fetchEquipmentModelById(props.match.params.id))
            handleCloseModal();
            setActualValue(result);
          }
        });
      }
    );
  };

  const handleDeleteGroup = (e, group) => {
    e.preventDefault()
    e.stopPropagation();
    confirm(`${i18n.t('handleDeleteGroupModalEquipService.confirm')} ${group.name}?`, {
      title: i18n.t('handleDeleteGroupModalEquipService.title'),
      titleColor: 'red',
      disableBackdrop: true,
    }).then(
      () => {},
      async () => {
        deleteQuestion(group).then((result) => {
          if (result !== 'error') {
            dispatch(actions.updateEquipmentServiceInModel(result));
            setActualValue(result);
          }
        });
      }
    );
  };

  const handleInactivateService = () => {
    inactivateService().then((result) => {
      if (result !== 'error') {
        props.closeModal(false, '');
        dispatch(actions.fetchEquipmentModelById(props.match.params.id))
      }
    });
  }


  const handleActivateService = () => {
    activateService().then((result) => {
      if (result !== 'error') {
        props.closeModal(false, '');
        dispatch(actions.fetchEquipmentModelById(props.match.params.id))
      }
    });
  }
    
  

  const handleActivateInactivateButton = () => {
    if (props.active) handleInactivateService();
    else handleActivateService();
  }

  const buttonText = props.active ? i18n.t('warningModalEquipService.titleInactivate') : i18n.t('warningModalEquipService.titleActivate');

  const styles = {
    opacityContainer: {
      opacity: loadingServiceTypes || loadingFrequency ? '0.3' : '1',
      position: 'relative',
    },
    groupContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginLeft: 5,
      cursor: 'pointer',
      fontSize: '1.5rem',
    },
    groupLabel: {
      fontWeight: 'bold',
    },
    createButton: {
      marginLeft: 20,
      background: '#bbd2ca',
      border: 'none',
      fontSize: 11,
      fontWeight: 400,
      borderRadius: 15,
      padding: '5px 10px 5px 10px',
      cursor: 'pointer',
    },
    toggleButtonLabel: {
      marginTop: 8,
      fontSize: '0.8rem',
      color: 'rgba(0, 0, 0, 0.54)',
    },
    buttonExport: {
      marginLeft: '20px',
      background: '#eee',
      border: 'none',
      fontWeight: '400',
      borderRadius: '15px',
      padding: '5px 10px 5px 10px',
      cursor: 'pointer',
    }
  };

  return <>
    <FormStyled onSubmit={handleSubmit}>
      {(loading || loadingChecklist) && <Spinner overlay />}
      <DivFormTitle  style={styles.opacityContainer}>
        <Typography variant="h6">
          {isNewData ? i18n.t('typographyModelEquipService.true') : i18n.t('typographyModelEquipService.false')}
        </Typography>
        {!isNewData && (
          <DivSubmitButtons>
            {editMode ? (
              <>
                <IconButton onClick={handleClickCancelEdit} size="large">
                  <CloseIcon color="error" />
                </IconButton>
                <IconButton type="submit" size="large">
                  <DoneIconStyled />
                </IconButton>
              </>
            ) : (
              <>
                <LoadingButton sx={{ marginRight: '5px'}} loading={loading} variant='outlined' color={props.active ? 'error' : 'primary'} onClick={() => setShowWarningModal(true)} size='small'>
                  {buttonText}
                </LoadingButton>
                <IconButton
                  onClick={() => handleCheckDeleteEquipmentServices(actualValue)}
                  size="large">
                  <DeleteIcon />
                </IconButton>
                <IconButton onClick={() => setEditMode(true)} size="large">
                  <EditIcon />
                </IconButton>
              </>
            )}
          </DivSubmitButtons>
        )}
      </DivFormTitle>

      { (!props.active && !isNewData) && <Box sx={{ padding: '6px 16px', backgroundColor: '#FDEDED', borderRadius: '8px', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginTop: '20px'}}>
          <ErrorOutlineIcon color='error' />
          <Box sx={{ marginLeft: '12px'}}>
            <Typography sx={{ fontSize: 16, fontWeight: 500, color: '#5F2120'}}>{i18n.t('typographyModelEquipService.warningTitle')}</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 400, color: '#5F2120'}}>{i18n.t('typographyModelEquipService.warningText')}</Typography>
          </Box>
        </Box>
      }

      <FormControl variant="standard" fullWidth margin="normal" required>
        <Autocomplete
          loading={loadingServiceTypes} // sent to isLoading
          label={i18n.t('autocompleteModalEquipService.serviceType')}
          data={serviceTypesFormated} // sent to options
          onSelectValue={handleInputChangeServiceTypes} // sent to onChange
          valueSelected={selectedServiceTypes} // sent to value
          newSearchText={handleInputChangeSelectorServiceTypes}
          name="serviceType"
          hasError={serviceTypesError}
          disabled={!editMode && !isNewData}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin="normal" required>
        <Autocomplete
          loading={loadingFrequency} // sent to isLoading
          label={i18n.t('autocompleteModalEquipService.frequency')}
          data={frequencyFormated} // sent to options
          onSelectValue={handleInputChangeFrequency} // sent to onChange
          valueSelected={selectedFrequency} // sent to value
          newSearchText={handleInputChangeSelectorFrequency}
          name="frequency"
          hasError={frequencyError}
          disabled={!editMode && !isNewData}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal'>
        <FormControlLabel
          disabled={!editMode && !isNewData}
          control={<Switch checked={mandatory} onChange={e => setMandatory(e.target.checked)} />}
          label={i18n.t('autocompleteModalEquipService.mandatory')}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal'>
        <FormControlLabel
          control={
            <Switch checked={expirationOnLastDayOfMonth} onChange={e => setExpirationOnLastDayOfMonth(e.target.checked)} />
          }
          label={i18n.t('autocompleteModalEquipService.expirationOnLastDayOfMonth')}
          disabled={!isNewData && !editMode}
        />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal'>
        <FormControlLabel
          control={
            <Switch checked={enableSignature} onChange={e => { setEnableSignature(e.target.checked); if (!e.target.checked) setMandatorySignature(false)}} />
          }
          label={i18n.t('autocompleteModalEquipService.enableSignature')}
          disabled={!isNewData && !editMode}
        />
        <FormControlLabel
          control={
            <Switch checked={mandatorySignature} onChange={e => setMandatorySignature(e.target.checked)} />
          }
          label={i18n.t('autocompleteModalEquipService.mandatorySignature')}
          disabled={(!isNewData && !editMode) || !enableSignature}
          sx={{marginLeft: '15px'}}
        />
      </FormControl>
      { role === 'admin' &&
        <FormControl variant="standard" fullWidth margin='normal'>
          <FormControlLabel
            disabled={!editMode && !isNewData}
            control={<Switch checked={mandatoryActions} onChange={e => setMandatoryActions(e.target.checked)} />}
            label={i18n.t('autocompleteModalEquipService.mandatoryActions')}
          />
        </FormControl>
      }
      { role === 'admin' &&
        <FormControl variant="standard" fullWidth margin='normal'>
          <FormControlLabel
            disabled={!editMode && !isNewData}
            control={<Switch checked={massService} onChange={e => setMassService(e.target.checked)} />}
            label={i18n.t('autocompleteModalEquipService.allowMassService')}
            sx={{marginBottom: '30px'}}
          />
        </FormControl>
      }
      {!isNewData && (
        <SiteSelector
          selectedSites={selectedSites}
          selectSite={(site) => selectSite(site)}
        />
      )}

      {!isNewData && (
        <div style={{margin: '10px 0'}}>
          <div style={{display: 'flex', alignItems: 'center', marginBottom: 10, marginTop: 10 }}>
            <Typography variant="h6" style={{color: '#437d6c', fontWeight: 600}}>
              Checklist
            </Typography>
            {selectedSites.length > 0 &&
              hasSiteAccess(selectedAccess, selectedSites[0]._id) && (
              <GroupCreateButton onClick={handleClickAddGroup}>
                {i18n.t('groupCreateButtonModalEquipService.text')}
              </GroupCreateButton>
              )}
            {selectedSites.length > 0 &&
              hasSiteAccess(selectedAccess, selectedSites[0]._id) && (
              <DeleteChecklistButton onClick={handleClickDeleteChecklist}>
                {i18n.t('deleteChecklistButton.text')} <DeleteIcon />
              </DeleteChecklistButton>
              )}
            {selectedSites.length > 0 && superadmin &&
              hasSiteAccess(selectedAccess, selectedSites[0]._id) && (
              <Button
                sx={styles.buttonExport}
                onClick={handleClickMassiveImport}
                endIcon={ <CloudUploadIcon /> }
              >
                {'Importação Massiva'}
              </Button>
            )}
            {selectedSites.length > 0 && superadmin && (
              
                <Button
                  sx={styles.buttonExport}
                  onClick={handleClickExport}
                  endIcon={
                    downloadingExcell ?
                      <CircularProgress size={16} sx={{ color: 'green' }}/>
                      :
                      <CloudDownload fontSize='large'/>
                  }
                >
                  {'Exportar Checklist'}

                </Button>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              margin: '10px 0',
            }}
          >
            {groupQuestionArray &&
              groupQuestionArray.length === 0 &&
              selectedSites.length > 0 &&
              hasSiteAccess(selectedAccess, selectedSites[0]._id) && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '10px 0',
                  }}
                >
                  <Button variant="outlined" onClick={handleClickAddGroup}>
                    {i18n.t('buttonModalEquipService.text')}
                  </Button>
                </div>
              )}
            {selectedSites.length === 0 && <div>{i18n.t('divModalEquipService.text')}</div>}
            <Checklist
              data={groupQuestionArray}
              handleEditGroup={handleClickEditGroup}
              handleDeleteGroup={handleDeleteGroup}
              handleClickEditQuestion={handleClickEditQuestion}
              handleClickAddQuestion={handleClickAddQuestion}
              detailsEnabled
              editionVersion={hasSiteAccess(selectedAccess, selectedSites[0]._id)} // To hide the create and edit options
            />
          </div>
        </div>
      )}

      {isNewData && (
        <DivSubmitButtons>
          <IconButton onClick={() => props.closeModal(false, '')} size="large">
            <CloseIcon fontSize="large" color="error" />
          </IconButton>
          <IconButton type="submit" size="large">
            <DoneIconStyled fontSize="large" />
          </IconButton>
        </DivSubmitButtons>
      )}
    </FormStyled>

    <WarningModal
      show={showWarningModal}
      close={() => setShowWarningModal(false)}
      title={ buttonText }
      text={ props.active ? i18n.t('warningModalEquipService.textInactivate') : i18n.t('warningModalEquipService.textActivate') }
      text2={ props.active ? i18n.t('warningModalEquipService.text2Inactivate') : i18n.t('warningModalEquipService.text2Activate') }
      confirmButtonText={ props.active ? i18n.t('warningModalEquipService.confirmButtonTextInactivate') : i18n.t('warningModalEquipService.confirmButtonTextActivate') }
      submit={handleActivateInactivateButton}
      cancelButtonColor={props.active ? 'primary' : 'error'}
      okButtonColor={props.active ? 'error' : 'primary'}
    />

    <Dialog
      maxWidth="xs"
      scroll="body"
      fullWidth
      open={openModalGroup}
      onClose={() => handleCloseDialog('group')}
      PaperProps={{
        style: {
          overflow: 'visible',
        },
      }}
    >
      <ModalEquipmentServicesGroup
        closeModal={handleCloseModal}
        modalContent={modalContentGroup}
        equipmentServiceId={!isEmpty(actualValue) && actualValue._id}
      />
    </Dialog>

    { (selectedSites && !isEmpty(selectedSites[0])) &&
      <Dialog
        maxWidth="md"
        scroll="body"
        fullWidth
        open={openModalQuestion}
        onClose={() => handleCloseDialog('question')}
        PaperProps={{
          style: {
            overflow: 'visible',
          },
        }}
      >
        <ModalEquipmentServicesQuestion
          closeModal={handleCloseDialog}
          modalGroupContent={modalGroupContentQuestion}
          modalContent={modalContentQuestion}
          equipmentServiceId={!isEmpty(actualValue) && actualValue._id}
          deleteButton={hasSiteAccess(selectedAccess, selectedSites[0]._id)}
          handleDelete={handleDeleteQuestion}
          allGroups={groupQuestionArray}
          changesFunc={setChangesOnStage}
          setActualValue={setActualValue}
        />
      </Dialog>
    }

    { (selectedSites && !isEmpty(selectedSites[0]) && superadmin) &&
      <Dialog
      maxWidth="ms"
      scroll="body"
      fullWidth
      open={openModalMassiveImport}
      PaperProps={{
        style: {
          overflow: 'visible',
        },
      }}
    >
      <ModalMassiveImport
        closeModal={handleCloseModal}
        equipmentServiceId={!isEmpty(actualValue) && actualValue._id}
        recovery={recovery}
        equipmentModelId={props.match.params.id}
      />
    </Dialog>}
  </>;
};

export default withRouter(ModalParamEquipmentServices);

const TypographyHover = styled(Typography)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
